// extracted by mini-css-extract-plugin
module.exports = {"container":"Videos_container__1Fyz9"};